import React from "react";

import { connect } from "../i18n/connect";
import { actions as priceAlertActions } from "../redux/modules/priceAlerts";
import {
  getPriceAlerts,
  getPriceAlertsLoading
} from "../redux/modules/priceAlerts/selector";
import withFormBuilder from "./withFormBuilder";

export default function withPriceAlerts(WrappedComponent) {
  const mapStateToProps = state => ({
    reduxPriceAlerts: getPriceAlerts(state),
    reduxPriceAlertsLoading: getPriceAlertsLoading(state)
  });

  const mapDispatchToProps = {
    addPriceAlert: priceAlertActions.addPriceAlert,
    deletePriceAlert: priceAlertActions.deletePriceAlert,
    fetchPriceAlerts: priceAlertActions.fetchPriceAlerts
  };

  @connect(mapStateToProps, mapDispatchToProps)
  @withFormBuilder(() => [
    {
      name: "value",
      type: "text",
      value: "",
      label: "Price",
      required: false,
      fullWidth: true,
      validationErrors: {
        isDefaultRequiredValue: "This field is required"
      },
      inputMode: "numeric"
    },
    {
      name: "comment",
      type: "text",
      multiline: true,
      rows: 3,
      fullWidth: true,
      value: "",
      label: "Comment to price alert",
      required: false,
      maxLength: 100
    }
  ])
  class WithPriceAlerts extends React.Component {
    render() {
      const {
        priceAlerts: ownedAlerts,
        priceAlertsLoading: ownedLoading,
        fetchPriceAlerts: ownedFetch,
        reloadPriceAlerts,
        reduxPriceAlerts,
        reduxPriceAlertsLoading,
        fetchPriceAlerts,
        addPriceAlert,
        deletePriceAlert,
        ...rest
      } = this.props;

      const usingExternalList = Array.isArray(ownedAlerts);

      const wrappedAddPriceAlert = (
        stockId,
        alertData,
        form,
        clearFormBuilder
      ) => {
        addPriceAlert(stockId, alertData, form, clearFormBuilder, () => {
          if (typeof reloadPriceAlerts === "function") {
            reloadPriceAlerts();
          }
        });
      };

      // Renew passes a callback that adds the replacement alert. That add
      // reloads the list when it succeeds, so reloading here would race it.
      const wrappedDeletePriceAlert = (
        stockId,
        alertId,
        silent,
        callback,
        skipConfirm
      ) => {
        deletePriceAlert(
          stockId,
          alertId,
          silent,
          () => {
            if (typeof callback === "function") {
              callback();
              return;
            }

            if (typeof reloadPriceAlerts === "function") {
              reloadPriceAlerts();
            }
          },
          skipConfirm
        );
      };

      return (
        <WrappedComponent
          {...rest}
          priceAlerts={usingExternalList ? ownedAlerts : reduxPriceAlerts}
          priceAlertsLoading={
            typeof ownedLoading === "boolean"
              ? ownedLoading
              : reduxPriceAlertsLoading
          }
          fetchPriceAlerts={
            usingExternalList ? () => undefined : fetchPriceAlerts
          }
          addPriceAlert={wrappedAddPriceAlert}
          deletePriceAlert={wrappedDeletePriceAlert}
          reloadPriceAlerts={reloadPriceAlerts}
        />
      );
    }
  }

  return WithPriceAlerts;
}
